import React from 'react'
import { CountryCode, PhoneNumber } from 'libphonenumber-js'

import { usePhone, PhoneGetPropsAttributes, PhoneGetProps } from './hook'

export interface PhoneRenderProps {
  error: string | undefined
  phoneNumber: PhoneNumber | null
  ref: React.RefCallback<HTMLInputElement>
  value?: string
  getProps: (props?: PhoneGetPropsAttributes) => PhoneGetProps
}

export interface PhoneProps {
  children: (props: PhoneRenderProps) => React.ReactElement | null
  defaultRegion?: CountryCode
  value?: string
}

const Phone = React.memo(
  ({ children, defaultRegion, value: defaultValue }: PhoneProps) => {
    const { error, phoneNumber, ref, value, getProps } = usePhone({
      defaultRegion,
      value: defaultValue,
    })

    return children({
      error,
      phoneNumber,
      ref,
      value,
      getProps,
    })
  },
)

Phone.displayName = 'Phone'

export { Phone }
